"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchMemberExcel = exports.mergeExcelViewers = exports.splitDisplayName = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_query_1 = require("react-query");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const option_1 = require("../../../../../common/option");
const server_1 = require("../../../../../server");
const popup_1 = require("../../../../base/popup");
/* ────────────────────────────────────────────────────────────────────────────
 * 다시보기 일부 공개 — 참여자 엑셀 일괄 등록 팝업
 *
 * SMS 수신자 엑셀 업로드(SMSUploadExcel)와 같은 흐름:
 *  - [샘플파일](양식 다운로드)로 받은 파일(A열 '아이디')에 아이디를 채워 [등록]으로 첨부 → 첨부 즉시 업로드
 *  - 서버가 클래스 멤버와 매칭한 결과(member_id, display_name="이름(아이디)")만 돌려준다(저장 안 함)
 *  - 이미 등록된 참여자와의 중복은 여기서 제거하고 기존 목록 뒤에 붙인다. 실제 저장은 등록·수정 화면 [확인]
 * ──────────────────────────────────────────────────────────────────────────── */
const WatchMemberExcelStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 16px;

	.guide {
		color: var(--color-grey, #666666);
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: ${props => (props.$isMobile ? '13px' : '14px')};
		line-height: 150%;
		letter-spacing: -0.02em;
		white-space: pre-line;
	}

	.excel-row {
		display: flex;
		align-items: center;
		width: 100%;
	}
`;
/** "이름(아이디)" → { name, idf }. 형식이 다르면 전체를 이름으로 본다 */
const splitDisplayName = (displayName) => {
    const match = /^(.*)\(([^()]*)\)\s*$/.exec(displayName ?? '');
    if (!match)
        return { name: displayName ?? '' };
    return { name: match[1].trim(), idf: match[2].trim() || undefined };
};
exports.splitDisplayName = splitDisplayName;
/** 업로드 결과를 기존 참여자 뒤에 붙인다 — 이미 있는 참여자(id 기준)·결과 내 중복은 제외 */
const mergeExcelViewers = (members, receivers) => {
    const known = new Set(members.map(member => member.id));
    const added = [];
    let duplicate = 0;
    for (const receiver of receivers) {
        if (!receiver?.member_id)
            continue;
        if (known.has(receiver.member_id)) {
            duplicate++;
            continue;
        }
        known.add(receiver.member_id);
        added.push({ id: receiver.member_id, ...(0, exports.splitDisplayName)(receiver.display_name) });
    }
    return { merged: [...members, ...added], added: added.length, duplicate };
};
exports.mergeExcelViewers = mergeExcelViewers;
exports.WatchMemberExcel = react_1.default.memo(({ members, setMembers, }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [file, setFile] = react_1.default.useState([]);
    const uploadingRef = (0, react_1.useRef)(false);
    const uploadMutation = (0, react_query_1.useMutation)(server_1.postReplayViewerExcel);
    const closePopup = () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, undefined);
    const handlerDownload = () => {
        window.location.href = server_1.REPLAY_VIEWER_EXCEL_FORM_URL;
    };
    (0, react_1.useEffect)(() => {
        if (file.length === 0 || uploadingRef.current)
            return;
        const upload = async () => {
            uploadingRef.current = true;
            APP.eventManager.publish('SHOW_LOADING', true);
            try {
                const response = await uploadMutation.mutateAsync(file[0]);
                const receivers = response?.result?.receivers ?? [];
                const skip = response?.result?.skip ?? 0;
                if (receivers.length === 0) {
                    alert(skip > 0
                        ? `클래스에 등록된 아이디가 없습니다. (확인되지 않은 아이디 ${skip}건)\n아이디를 확인한 뒤 다시 첨부해 주세요.`
                        : '등록할 아이디가 없습니다. 양식의 아이디 열을 확인해 주세요.');
                    setFile([]);
                    return;
                }
                const { merged, added, duplicate } = (0, exports.mergeExcelViewers)(members ?? [], receivers);
                setMembers(merged);
                const notes = [
                    duplicate > 0 ? `이미 등록된 참여자 ${duplicate}명 제외` : '',
                    skip > 0 ? `확인되지 않은 아이디 ${skip}건 제외` : '',
                ].filter(Boolean);
                alert(`참여자 ${added}명을 추가했습니다.${notes.length ? `\n(${notes.join(', ')})` : ''}`);
                closePopup();
            }
            catch (error) {
                console.error('[WatchMemberExcel] 엑셀 업로드 실패', error);
                alert(typeof error === 'string' ? error : '파일 업로드에 실패했습니다.');
                setFile([]);
            }
            finally {
                uploadingRef.current = false;
                APP.eventManager.publish('SHOW_LOADING', false);
            }
        };
        upload();
    }, [file]);
    return (react_1.default.createElement(WatchMemberExcelStyled, { "$isMobile": isMobile },
        react_1.default.createElement("p", { className: "guide" }, '[샘플파일]로 받은 엑셀의 아이디 열에 참여자 아이디를 입력한 뒤 [등록]으로 첨부해 주세요.\n첨부하면 바로 참여자 목록에 추가됩니다. (저장은 화면 하단 [확인]에서)'),
        react_1.default.createElement("div", { className: "excel-row" },
            react_1.default.createElement(option_1.FileAttach, { id: "replay-viewer-excel", isRegist: true, isNotice: true, fileList: file, setAttachFileList: (list) => setFile(list), isSMSRegist: true, handlerDownload: handlerDownload }))));
});
